var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-dialog',{ref:"dialog",attrs:{"title":_vm.title,"height":"50vh"},on:{"resolve":_vm.resolveHandle}},[_c('c-form',[_c('c-form-item',{attrs:{"label":_vm.label,"required":""}},[_c('c-input',{attrs:{"type":"textarea","placeholder":_vm.placeholder},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }